module.exports = __webpack_public_path__ + "static/media/btn_eli_active.c25454bc.png";